import { RecordRenewalStatus, RecordTypeStatusType } from 'types/graphql'

import Tag, { TagColor } from 'src/components/Tag'

type Props = {
  isDraft?: boolean
  status?: {
    name: string
    type: RecordTypeStatusType
    renewalStatus?: RecordRenewalStatus | null
  } | null
  isArchived?: boolean
}

/**
 * Maps system renewal lifecycle statuses to badge colors. Mirrors the renewals
 * prototype StatusBadge and overrides the underlying RecordTypeStatusType seed
 * (e.g. Active is stored as InProgress but renders green).
 */
export const getRenewalStatusTagColor = (renewalStatus: RecordRenewalStatus): TagColor | null => {
  switch (renewalStatus) {
    case 'Active':
    case 'Renewed':
      return 'green'
    case 'EligibleToRenew':
    case 'RenewalInProgress':
      return 'yellow'
    case 'GracePeriod':
      return 'yellow'
    case 'LatePeriod':
    case 'Expired':
      return 'red'
    default:
      return null
  }
}

const getColor = (
  type: RecordTypeStatusType,
  renewalStatus?: RecordRenewalStatus | null
): TagColor => {
  if (renewalStatus) {
    const renewalColor = getRenewalStatusTagColor(renewalStatus)
    if (renewalColor) {
      return renewalColor
    }
  }

  switch (type) {
    case 'ToDo': {
      return 'blue'
    }
    case 'InProgress': {
      return 'yellow'
    }
    case 'Complete': {
      return 'green'
    }
    case 'CompleteNegative': {
      return 'red'
    }
  }
}

export const RecordTypeStatusDisplay = (props: Props) => {
  const { isDraft, status, isArchived } = props
  if (isDraft) {
    return <Tag color="default">Draft</Tag>
  }
  const name = status?.name
  const type = status?.type
  const color = type ? getColor(type, status?.renewalStatus) : 'default'
  return (
    <Tag color={color}>
      {name}
      {isArchived && ' (Archived)'}
    </Tag>
  )
}
